var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-liveview-ico"},[_c('span',[_c('SelectOptions'),_c('Legend')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }